export default __webpack_public_path__ + "static/media/germany_flag.3f699710.png";